import { SettingsOutletLayout } from "~/providers/components/providerSettings/SettingsOutletLayout";
import { SupplementalQuestions } from "~/providers/components/tools/SupplementalQuestions";

export const ConsultationOptionsScreen = () => {
  return (
    <SettingsOutletLayout>
      <SupplementalQuestions />
    </SettingsOutletLayout>
  );
};
